import { useRoutes } from "react-router-dom";
import Authentication from "pages/authentication/Authentication";
import ForgotPassword from "pages/forgot-password/ForgotPassword";
import Login from "pages/login/Login";
import Registration from "pages/registration/Registration";
import RegistrationCoBorrower from "pages/registration/RegistrationCoBorrower";
import Documents from "pages/dashboard/documents/Documents";
import Header from "components/ui/header/Header";
import RequireAuth from "features/RequireAuth";
import PublicRoute from "features/PublicRoute";
import Version from "pages/version/Version";
import Welcome from "pages/welcome/Welcome";
import RecoverPassword from "pages/recover-password/RecoverPassword";
import Mfa from "pages/MFA/MFA";
import RegistrationAuth from "pages/authentication/RegistrationAuth";
import AuthRouting from "components/auth-routing/AuthRouting";
import MyLoansRoute from "./my-loans-route/MyLoansRoute";
import RaNHRedirect from "pages/raNHRedirect/RaNHRedirect";
import External from "pages/external/External";
import UpdatePassword from "pages/update-password/UpdatePassword";
import UserGateway from "pages/user-gateway/UserGateway";
import ExternalRegistration from "pages/registration/ExternalRegistration";
import DashboardRouter from "pages/dashboard/DashboardRouter";
import DashboardShellContent from "./dashboard-shell-content/DashboardShellContent";
import HomeShellLayout from "./home-shell-layout/HomeShellLayout";
import ApplicationShellLayout from "./application-shell-layout/ApplicationShellLayout";
import Impersonate from "pages/impersonate/Impersonate";
import SelfRegistration from "pages/self-registration/SelfRegistration";

export type Route =
  | "/"
  | "/authcode"
  | "/registrationAuth"
  | "/mfa"
  | "/registration"
  | "/registrationCoBorrower"
  | "/forgotpassword"
  | "/resetpassword"
  | "/thankyou"
  | "/path"
  | "/application"
  | "/home"
  | "/apitests"
  | "/dashboard"
  | "/versions"
  | "/applicationcomplete"
  | "/los"
  | "/my-loans"
  | "/external"
  | "/interim-welcome"
  | "/form"
  | "/updatePassword";

export function Routes() {
  const routes = useRoutes([
    {
      path: "/",
      element: <Header />,
      children: [
        {
          element: <PublicRoute />,
          children: [
            { index: true, element: <Login /> },
            {
              path: "registration",
              element: <Registration />,
            },
            {path: "impersonate",
              element:<Impersonate/>
            },
            {path: "form",
              element:<SelfRegistration/>
            },
            {
              path: "form/nmls/:loNmlsNumber/src/:branchId",
              element: <SelfRegistration />,
            },
            {
              path: "registrationCoBorrower",
              element: <RegistrationCoBorrower />,
            },
            {
              path: "forgotpassword",
              element: <ForgotPassword />,
            },
            {
              path: "mfa",
              element: <Mfa />,
            },
            {
              path: "authcode",
              element: <Authentication />,
            },
            {
              path: "registrationAuth",
              element: <RegistrationAuth />,
            },
            { path: "resetpassword", element: <RecoverPassword /> }, 
            { path: "updatepassword", element: <UpdatePassword /> },
            { path: "start", element: <UserGateway /> },
            { path: "external-registration", element: <ExternalRegistration /> }
          ],
        },
        {
          element: <RequireAuth />,
          children: [
            { path: "post-auth", element: <AuthRouting /> },
            { path: "path", element: <Welcome /> },
            {
              path: "my-loans",
              element: <MyLoansRoute />,
            },
            { path: "home", element: <HomeShellLayout /> },
            { path: "application", element: <ApplicationShellLayout /> },
            {
              path: "dashboard",
              element: <DashboardShellContent />,
              children: [
                { index: true, element: <DashboardRouter /> },
                {
                  path: "documents",
                  element: <Documents />,
                },
              ],
            },
           {
              path: "external",
              element: <External />,
            },
          ],
        },
        { path: "versions", element: <Version /> },
      ],
    },
    {
      path: "/ra",
      element: <RaNHRedirect />,
    },
  ]);
  return routes;
}
